import { SkeletonComponent, skeletonTemplate } from './Skeleton';
import styles from './Skeleton.styles.scss';
export const skeletonDefinition = {
    baseName: 'skeleton',
    template: skeletonTemplate,
    styles,
};
export const chameleonSkeleton = SkeletonComponent.compose(skeletonDefinition);
